import React from 'react';
import format from 'date-fns/format';
import { useSelector } from 'react-redux';

import {
  TableRow,
  Checkbox,
  TableCell,
  Pagination,
  WrapperFlex,
} from '@unimed-fesp/components';

import LoadingSpinning from '../../molecules/LoadingSpinning';
import EmptyContent from '../../molecules/EmptyContent';

const TableBeneficiarioBody = ({
  selectedBeneficiario,
  handleCheckBeneficiario,

  handleChangePage,
  paginationParams,
  setPaginationParams,
  handlePageChangeKeyDown,
}) => {
  const { data: beneficiarios, loading, total } = useSelector(
    (state) => state.lista.postPesquisaBeneficiario
  );

  if (loading)
    return (
      <TableRow>
        <TableCell colSpan={7}>
          <LoadingSpinning height="230px" />
        </TableCell>
      </TableRow>
    );

  if (beneficiarios.length <= 0)
    return (
      <TableRow>
        <TableCell colSpan={7}>
          <EmptyContent />
        </TableCell>
      </TableRow>
    );

  return (
    <>
      {beneficiarios.map((beneficiario) => (
        <TableRow
          onClick={() => {
            if (beneficiario?.cpf === selectedBeneficiario?.cpf)
              handleCheckBeneficiario(null);
            else handleCheckBeneficiario(beneficiario);
          }}
          isClickable
        >
          <TableCell>
            <WrapperFlex alignCenter justifyCenter>
              <Checkbox
                height={18}
                width={18}
                checked={
                  beneficiario?.codigo === selectedBeneficiario?.codigo &&
                  beneficiario?.modalidadeTitular ===
                    selectedBeneficiario?.modalidadeTitular &&
                  beneficiario?.termo === selectedBeneficiario?.termo
                }
              />
            </WrapperFlex>
          </TableCell>
          <TableCell>{beneficiario.nome ? beneficiario.nome : '-'}</TableCell>
          <TableCell>
            {beneficiario.cpf
              ? beneficiario?.cpf.replace(
                  /(\d{3})(\d{3})(\d{3})(\d{2})/,
                  '$1.$2.$3-$4'
                )
              : '-'}
          </TableCell>
          <TableCell>
            {beneficiario.codigo ? beneficiario.codigo : '-'}
          </TableCell>
          <TableCell>
            {`${
              beneficiario.codigoUnimed
                ? beneficiario.codigoUnimed.padStart(4, '0')
                : '-'
            } ${
              beneficiario.carteira
                ? beneficiario.carteira.padStart(13, '0')
                : '-'
            }`}
          </TableCell>
          <TableCell>
            {beneficiario.nascimento
              ? format(new Date(beneficiario.nascimento), 'dd/MM/yyyy', {
                  timeZone: 'America/Sao_Paulo',
                })
              : '-'}
          </TableCell>
        </TableRow>
      ))}
      <TableRow>
        <TableCell colSpan={7}>
          <Pagination
            total={total}
            paginationParams={paginationParams}
            setPaginationParams={setPaginationParams}
            handlePageChangeKeyDown={handlePageChangeKeyDown}
            callbackChangePage={handleChangePage}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default TableBeneficiarioBody;
